import _ from 'lodash';
import async from 'async';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'classnames';

//- material-ui
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

//- UI
import BlockPicker from './BlockPicker';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import FMPHeadline from '../../components/ui/FMPHeadline';
import OcrGuideContainer from '../../containers/ocr/OcrGuide';
import OcrGuideDocumentContainer from '../../containers/ocr/OcrGuideDocument';
import { getSharedStyles } from '../../themes';
import FormComponent from '../../components/FormComponent';
import FMPSelect from '../../components/pureForm/FMPSelect';
import FMPCarrierSelect from '../../components/pureForm/FMPCarrierSelect';
import ResourceUploader from '../../components/form/ResourceUploader';
import ResourceListing from '../../components/resource/resourceListing';
// import FMPTerminalSupplierPicker from '../../components/pureForm/FMPTerminalSupplierPicker';
import FMPTerminalPicker from '../../components/pureForm/FMPTerminalPicker';
import FMPSupplierPicker from '../../components/pureForm/FMPSupplierPicker';
import FMPProductSelect from '../../components/pureForm/FMPProductSelect';
import FMPCheckbox from '../../components/pureForm/FMPCheckbox';
import FMPText from '../../components/pureForm/FMPText';

const rgbKeyValueColors = [
	{ r: 244, g: 67, b: 54 },
	{ r: 233, g: 30, b: 99 },
	{ r: 156, g: 39, b: 176 },
	{ r: 103, g: 58, b: 183 },
	{ r: 63, g: 81, b: 181 },

	{ r: 33, g: 150, b: 243 },
	{ r: 3, g: 169, b: 244 },
	{ r: 0, g: 188, b: 212 },
	{ r: 0, g: 150, b: 136 },
	{ r: 76, g: 175, b: 80 },

	{ r: 139, g: 195, b: 74 },
	{ r: 205, g: 220, b: 57 },
	{ r: 255, g: 235, b: 59 },
	{ r: 255, g: 193, b: 7 },
	{ r: 255, g: 152, b: 0 },

	{ r: 255, g: 87, b: 34 },
	{ r: 121, g: 85, b: 72 },
];

const styles = (theme) => ({
	...getSharedStyles(theme),
	submitButton: {
		fontSize: 17,
		borderRadius: '100px',
		padding: '15px 25px',
		textTransform: 'uppercase',
		marginTop: 30,
	},

	block: {
		position: 'absolute',
		borderRadius: '1px',
		boxSizing: 'border-box',
		fontSize: 10,
		transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
		cursor: 'pointer',
		'&:hover': {
			border: '2px solid rgba(3,169,244 ,1)',
			backgroundColor: 'rgba(3,169,244 ,.2)',
		},
	},
	keyBlocks: {
		//border: '2px solid rgba(39,245,74, 1)',
		//backgroundColor: 'rgba(39,245,74 ,.2)',
	},
	blockContainer: {
		borderLeft: '2px solid #bbb',
		padding: `7px 15px 10px 15px`,
		marginBottom: 10,
	},
	addInputButton: {
		borderRadius: '100px',
		marginTop: 20,
	},
});

/*
const Superior_509066_ResourceId = 888888895;
const Superior_509064_ResourceId = 888888893;
const Superior_509069_ResourceId = 888888894;
const sampleResourceIds = [Superior_509064_ResourceId, Superior_509066_ResourceId, Superior_509069_ResourceId];

*/

/*
const fds1 = 888888902;
const fds2 = 888888900;
const fds3 = 888888901;
const sampleResourceIds = [fds1, fds2, fds3];
 */

/*
const mvp1 = 888888900;
const mvp2 = 888888901;
const mvp3 = 888888902;
const sampleResourceIds = [mvp1, mvp2, mvp3];
 */
/*
const mvp1 = 888888898;
const mvp2 = 888888899;
const mvp3 = 888888897;
const sampleResourceIds = [mvp1, mvp2, mvp3];
 */

//RESOURCE IDS [ 888888895, 888888896, 888888894 ]

//- XXX the whole point of the GUIDE is to determine the anchor points of the lines. Analyze all three "value"
//- blocks and then write down which points stay relatively the same. Those are the points I need to match up
//- against when try to make a match. Essentially is it left aligned, or right aligned. top aligned, bottom aligned.

//- OCR guide should let me flip between all three documents. neat to have an ONOIN skin as well.

function getBlockDiff(keyBlock, valueBlock) {
	//- This is the one we have
	const keyLeft = keyBlock.Geometry.BoundingBox.Left;
	const keyTop = keyBlock.Geometry.BoundingBox.Top;

	const valueLeft = valueBlock.Geometry.BoundingBox.Left;
	const valueTop = valueBlock.Geometry.BoundingBox.Top;

	const x = keyLeft - valueLeft;
	const y = keyTop - valueTop;
	return { x, y };
}

const indicatorDefaults = {
	carrierDeliveryTicket: {
		deliveryMatchingBlocks: [
			{
				field: 'stationDeliveryId',
				display: 'FMP Delivery ID',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'bulkDeliveryId',
				display: 'Bulk Delivery ID',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'stationNumber',
				display: 'Station Number',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'offloadTerminal',
				display: 'Offload Terminal',
				keyBlock: {},
				valueBlock: {},
			},
		],
		invoiceDataBlocks: [
			{
				field: 'carrierPoNumber',
				display: 'Carrier PO Number',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'deliveryDate',
				display: 'Delivery Date',
				keyBlock: {},
				valueBlock: {},
				showDateFormat: true,
			},
		],
	},
	stationDeliveryPickupBol: {
		invoiceDataBlocks: [
			{
				field: 'bolNumber',
				display: 'BOL Number',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'netFuelAmount',
				display: 'Net Fuel Gal',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'netFuelAmount2',
				display: 'Net Fuel Amount 2',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'pickupDate',
				display: 'Pickup Date',
				keyBlock: {},
				valueBlock: {},
				showDateFormat: true,
			},
		],
	},
	pickupBol: {
		invoiceDataBlocks: [
			{
				field: 'bolNumber',
				display: 'BOL Number',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'netGallons',
				display: 'Net Fuel Amount',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'pickupDate',
				display: 'Pickup Date',
				keyBlock: {},
				valueBlock: {},
				showDateFormat: true,
			},
		],
	},
	offloadBol: {
		invoiceDataBlocks: [
			{
				field: 'bolNumber',
				display: 'BOL Number',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'rinCredit2025netGallons',
				display: 'Net Fuel Amt',
				keyBlock: {},
				valueBlock: {},
			},
			{
				field: 'pickupDate',
				display: 'Pickup Date',
				keyBlock: {},
				valueBlock: {},
				showDateFormat: true,
			},
		],
	},
};

class SaveOcrGuide extends FormComponent {
	constructor(props) {
		super(props);

		const ocrGuideId = _.get(this.props, ['match', 'params', 'ocrGuideId']);

		this.state = {
			ocrGuideId: ocrGuideId ? parseInt(ocrGuideId, 10) : undefined,
			isUpdate: ocrGuideId,
			isPicking: false,
			currentPickingPath: undefined,
			currentPickingType: undefined,
			prepResult: null,
			detectionIndicatorBlocks: [{}, {}, {}, {}],
			deliveryMatchingBlocks: [],

			invoiceDataBlocks: [],
			//shortCutAddResourceIds : [888888915, 888888916, 888888917]
			//shortCutAddResourceIds : [888888921, 888888922, 888888923], //- PDI
			isAlwaysSameFuelAndSupplier: false,
			supplierRegexes: [{ supplierId: '', regex: '' }],
			productTypeRegexes: [{ productType: '', regex: '' }],
			ocrGuideDocumentIds: [],
		};
	}

	componentDidMount() {
		const { ocrGuide, ocrGuideGet } = this.props;
		const { isUpdate, ocrGuideId } = this.state;

		if (!isUpdate) {
			return;
		}
		if (!ocrGuide) {
			ocrGuideGet({
				params: { ocrGuideIds: [ocrGuideId] },
			});
		} else {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (_.isUndefined(prevProps.ocrGuide) && !_.isUndefined(this.props.ocrGuide)) {
			const newState = this.fillForm();
			this.setState(newState);
		}

		const { isUpdate, documentCategory } = this.state;
		if (!isUpdate && documentCategory && documentCategory !== prevState.documentCategory) {
			if (documentCategory === 'carrierDeliveryTicket') {
				this.setState(_.cloneDeep(indicatorDefaults.carrierDeliveryTicket));
			} else if (documentCategory === 'stationDeliveryPickupBol') {
				this.setState(_.cloneDeep(indicatorDefaults.stationDeliveryPickupBol));
			} else if (documentCategory === 'pickupBol') {
				this.setState(_.cloneDeep(indicatorDefaults.pickupBol));
			} else if (documentCategory === 'offloadBol') {
				this.setState(_.cloneDeep(indicatorDefaults.offloadBol));
			}
		}

		//- Maybe handle the upload here
	}

	getBlockSuggestions = () => {
		const { getBlockSuggestions, showErrors } = this.props;
		const { ocrGuideDocumentIds } = this.state;

		getBlockSuggestions({
			params: {
				ocrGuideDocumentIds,
			},
			callback: (err, prepResult) => {
				if (err) {
					return showErrors([err]);
				}

				const { allDocumentResults } = prepResult;
				const firstDocumentResult = allDocumentResults[0];
				const firstResourceBlocks = firstDocumentResult.ocrBlocks;

				const blocksById = _.keyBy(firstResourceBlocks, 'Id');
				const keyBlocks = [];

				//- Lets go through each Blocks
				firstResourceBlocks.forEach((Block) => {
					const { BlockType, Relationships, EntityTypes } = Block;
					if (BlockType !== 'KEY_VALUE_SET') {
						return;
					}

					if (!EntityTypes) {
						return;
					}
					if (_.first(EntityTypes) !== 'KEY') {
						return;
					}

					Block.childBlocks = [];
					Block.childTextString = '';
					Relationships.forEach((relationship) => {
						const { Type, Ids } = relationship;

						if (Type === 'VALUE') {
							const valueBlock = blocksById[_.first(Ids)];
							if (!valueBlock) {
								return;
							}
							if (!valueBlock.Relationships) {
								return;
							}

							valueBlock.childBlocks = [];
							valueBlock.childTextString = '';
							valueBlock.Relationships.forEach((valueRelationship) => {
								if (valueRelationship.Type === 'CHILD') {
									valueRelationship.Ids.forEach((childId) => {
										const childBlock = blocksById[childId];
										valueBlock.childBlocks.push(childBlock);
										valueBlock.childTextString += childBlock.Text;
									});
								}
							});

							Block.valueBlock = valueBlock;
						} else if (Type === 'CHILD') {
							Ids.forEach((childId) => {
								const childBlock = blocksById[childId];
								Block.childBlocks.push(childBlock);
								Block.childTextString += childBlock.Text;
							});
						}
					});

					//- Some don't have values
					if (!Block.valueBlock) {
						return;
					}

					keyBlocks.push(Block);
				});

				this.setState({
					blocksById,
					firstResourceBlocks,
					prepResult,
					keyBlocks,
				});
			},
		});
	};

	fillForm = () => {
		const { ocrGuide } = this.props;
		if (!ocrGuide) {
			return;
		}

		const newState = {};
		[
			'accountingCategory',
			'documentCategory',
			'carrierId',
			'terminalId',

			'detectionIndicatorBlocks',
			'deliveryMatchingBlocks',
			'invoiceDataBlocks',

			'isAlwaysSameFuelAndSupplier',
			'supplierId',
			'productType',
			'supplierRegexes',
			'productTypeRegexes',

			'ocrGuideDocumentIds',
		].forEach((key) => {
			if (_.isNil(ocrGuide[key])) {
				return;
			}
			newState[key] = ocrGuide[key];
		});

		const { documentCategory } = ocrGuide;

		// Fill in missing blocks added after the fact like for an upgrade

		_.keys(indicatorDefaults[documentCategory]).forEach((key) => {
			indicatorDefaults[documentCategory][key].forEach((dmb) => {
				const { field } = dmb;
				if (!_.find(newState[key], { field })) {
					newState[key].push(_.cloneDeep(dmb));
				}
			});
		});

		return newState;
	};

	handleSave = () => {
		const { showErrors, ocrGuideAdd, ocrGuideUpdate } = this.props;
		const { isUpdate, ocrGuideId } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			return showErrors(_.values(formFieldError));
		}

		const {
			accountingCategory,
			documentCategory,
			ocrGuideDocumentIds,
			carrierId,

			detectionIndicatorBlocks,
			deliveryMatchingBlocks,
			invoiceDataBlocks,

			isAlwaysSameFuelAndSupplier,
			supplierId,
			productType,
			supplierRegexes,
			productTypeRegexes,
			terminalId,
		} = this.state;

		//- document = carrierDelivery Ticket, make sure we have carrier
		//- if we have carrierDeliveryTicket make sure we have a match
		//- ake sure we have invoice data, etc, etc

		this.setState({ isSaving: true, savingSuccessful: false });

		const params = {
			accountingCategory,
			documentCategory,
			carrierId,

			detectionIndicatorBlocks,
			deliveryMatchingBlocks,
			invoiceDataBlocks,
			ocrGuideDocumentIds,
			isAlwaysSameFuelAndSupplier,
			terminalId,
		};

		if (isAlwaysSameFuelAndSupplier) {
			params.supplierId = supplierId;
			params.productType = productType;
		} else {
			params.supplierRegexes = supplierRegexes;
			params.productTypeRegexes = productTypeRegexes;
		}

		if (this.state.shortCutAddResourceIds && this.state.shortCutAddResourceIds.length === 3) {
			params.resourceIds = this.state.shortCutAddResourceIds;
		}

		this.setState({ isSaving: true });

		//if (_.isNumber(bulkFormulaId)) {
		//	params.bulkFormulaId = bulkFormulaId;
		//}

		if (!isUpdate) {
			ocrGuideAdd({ params });
		} else {
			params.ocrGuideId = ocrGuideId;
			ocrGuideUpdate({ params });
		}
	};

	handlePickBlock = ({ Block }) => {
		const { currentPickingPath } = this.state;
		this.onChange(Block, currentPickingPath);

		/*
		this.setState({
			isPicking : false,
			currentPickingPath : undefined,
			currentPickingType: undefined,
		});
		 */
	};

	addInput = (arrayName) => {
		this.setState({ [arrayName]: this.state[arrayName].concat(['']) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	handleBlockPickerOnStartPicking = ({ path, pickingType }) => {
		this.setState({
			isPicking: true,
			currentPickingPath: path,
			currentPickingType: pickingType,
		});
	};

	handleBlockPickerOnCancelPicking = () => {
		this.setState({
			isPicking: false,
			currentPickingPath: undefined,
			currentPickingType: undefined,
		});

		const {
			//blocksById,
			prepResult,
			invoiceDataBlocks,
		} = this.state;

		const { allDocumentResults, keyBlockIdToMatchingDocBlockId } = prepResult;

		const otherDocs = allDocumentResults.slice(1);

		//- Lets match stuff
		invoiceDataBlocks.forEach((deliveryMatchingBlock) => {
			const { display, keyBlock, valueBlock } = deliveryMatchingBlock;
			if (_.isEmpty(keyBlock) || _.isEmpty(valueBlock)) {
				return;
			}
			const { x, y } = getBlockDiff(keyBlock, valueBlock);

			console.log(`Trying to find match in other docs for: ${display}`);
			console.log(`First doc value:`, valueBlock.Text);

			const otherKeyBlocks = keyBlockIdToMatchingDocBlockId[keyBlock.Id];
			if (!otherKeyBlocks) {
				console.error('No other doc key blocks for ', keyBlock.Id);
				return;
			}

			otherDocs.forEach((doc) => {
				const { ocrBlocks, key } = doc;

				const matched = _.find(otherKeyBlocks, { key });
				if (!matched) {
					console.error('OTher docs did not have shared block');
					return;
				}

				const { blockId } = matched;
				const blocksById = _.keyBy(ocrBlocks, 'Id');
				const otherKeyBlock = blocksById[blockId];

				//- Got find the other keyBlock
				let bestDiff = 99999;
				let bestBlock = undefined;
				ocrBlocks.forEach((Block) => {
					const { BlockType } = Block;
					if (BlockType !== 'LINE') {
						return;
					}

					const r = getBlockDiff(otherKeyBlock, Block);
					const otherX = r.x;
					const otherY = r.y;

					const xDiff = Math.abs(x - otherX);
					const yDiff = Math.abs(y - otherY);

					if (xDiff + yDiff < bestDiff) {
						bestBlock = Block;
						bestDiff = xDiff + yDiff;
					}
				});
				console.log('    - Best block:', bestBlock.Text, bestDiff);
			});
		});
	};

	render() {
		const { classes } = this.props;

		const {
			accountingCategory,
			//documentCategory,
			//currentPickingPath,
			//detectionIndicatorBlocks,
			//deliveryMatchingBlocks,
			//invoiceDataBlocks,
		} = this.state;

		return (
			<Grid container spacing={2}>
				<Grid item xs={8}>
					<Paper className={classes.paper}>{this.renderDocumentPrep()}</Paper>
				</Grid>
				<Grid item xs={4}>
					<Paper className={classes.paper}>
						<FMPSelect
							{...this.setForm('accountingCategory', 'Accounting Category', true)}
							options={[
								{ display: 'Accounts Receivable', value: 'ar' },
								{ display: 'Accounts Payable', value: 'ap' },
							]}
						/>

						{!accountingCategory && <div>Pick an accounting category...</div>}
						{accountingCategory && (
							<>
								<FMPSelect
									{...this.setForm('documentCategory', 'Document Category', true)}
									options={[
										{ display: 'Carrier Delivery Ticket', value: 'carrierDeliveryTicket' },
										{ display: 'Station Delivery Pickup BOL', value: 'stationDeliveryPickupBol' },
										{ display: 'Bulk Delivery Pickup BOL', value: 'pickupBol' },
										{ display: 'Bulk Delivery Offload BOL', value: 'offloadBol' },
									]}
								/>
								{this.renderAccountCategoryOptions()}
							</>
						)}
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderAccountCategoryOptions = () => {
		const { documentCategory } = this.state;

		if (!documentCategory) {
			return <div>Pick an document category...</div>;
		}

		if (documentCategory === 'carrierDeliveryTicket') {
			return this.renderCarrierFields();
		} else if (documentCategory === 'stationDeliveryPickupBol') {
			return this.renderBolFields();
		} else if (documentCategory === 'pickupBol' || documentCategory === 'offloadBol') {
			return this.renderBolFields();
		} else {
			return <div>This document category has not been implemented yet</div>;
		}
	};

	renderCarrierFields = () => {
		const {
			currentPickingPath,
			detectionIndicatorBlocks,
			deliveryMatchingBlocks,
			invoiceDataBlocks,
		} = this.state;

		return (
			<>
				<FMPCarrierSelect {...this.setForm('carrierId', 'Carrier')} />

				<FMPSectionHeader label={'Detection Indicators'} />
				{detectionIndicatorBlocks.map((block, i) => {
					const path = `detectionIndicatorBlocks.${i}`;
					return (
						<BlockPicker
							key={path}
							{...this.setForm(path)}
							type={'key'}
							isActive={path === currentPickingPath} //- see if we are active
							startPicking={this.handleBlockPickerOnStartPicking}
							cancelPicking={this.handleBlockPickerOnCancelPicking}
						/>
					);
				})}

				<FMPSectionHeader label={'Delivery Matching'} />

				{deliveryMatchingBlocks.map((block, i) => {
					const path = `deliveryMatchingBlocks.${i}`;
					return (
						<BlockPicker
							key={path}
							{...this.setForm(path)}
							type={'keyAndValue'}
							isActive={path === currentPickingPath}
							startPicking={this.handleBlockPickerOnStartPicking}
							cancelPicking={this.handleBlockPickerOnCancelPicking}
						/>
					);
				})}

				<FMPSectionHeader label={'Invoice Data'} />
				{invoiceDataBlocks.map((block, i) => {
					const path = `invoiceDataBlocks.${i}`;
					return (
						<BlockPicker
							key={path}
							{...this.setForm(path)}
							type={'keyAndValue'}
							isActive={path === currentPickingPath}
							showDateFormat={block.field === 'deliveryDate'}
							startPicking={this.handleBlockPickerOnStartPicking}
							cancelPicking={this.handleBlockPickerOnCancelPicking}
						/>
					);
				})}
				{this.renderSaveButton()}
			</>
		);
	};

	renderBolFields = () => {
		const { currentPickingPath, detectionIndicatorBlocks, invoiceDataBlocks } = this.state;

		return (
			<>
				<FMPTerminalPicker
					{...this.setForm('terminalId', 'Terminal')}
					productTypes={['e85', 'etoh', 'unl']}
				/>

				{this.renderFuelSelection()}

				<FMPSectionHeader label={'Document Detection Indicators'} />
				{detectionIndicatorBlocks.map((block, i) => {
					const path = `detectionIndicatorBlocks.${i}`;
					return (
						<BlockPicker
							key={path}
							{...this.setForm(path)}
							type={'key'}
							isActive={path === currentPickingPath} //- see if we are active
							startPicking={this.handleBlockPickerOnStartPicking}
							cancelPicking={this.handleBlockPickerOnCancelPicking}
						/>
					);
				})}

				<FMPSectionHeader label={'Invoice Extract'} />
				{invoiceDataBlocks.map((block, i) => {
					const path = `invoiceDataBlocks.${i}`;
					return (
						<BlockPicker
							key={path}
							{...this.setForm(path)}
							type={'keyAndValue'}
							isActive={path === currentPickingPath}
							showDateFormat={block.showDateFormat}
							startPicking={this.handleBlockPickerOnStartPicking}
							cancelPicking={this.handleBlockPickerOnCancelPicking}
						/>
					);
				})}
				{this.renderSaveButton()}
			</>
		);
	};

	renderFuelSelection = () => {
		const { classes } = this.props;
		const {
			isAlwaysSameFuelAndSupplier,
			supplierRegexes,
			productTypeRegexes,
			terminalId,
		} = this.state;
		return (
			<div style={{ marginTop: 20 }}>
				<FMPCheckbox
					{...this.setForm(
						'isAlwaysSameFuelAndSupplier',
						'Is always same fuel and supplier?',
						false,
						false
					)}
				/>
				{isAlwaysSameFuelAndSupplier && (
					<>
						<FMPSupplierPicker
							{...this.setForm('supplierId', 'Supplier')}
							terminalId={terminalId}
						/>
						<FMPProductSelect
							{...this.setForm('productType', 'Product')}
							productTypes={['e85', 'etoh', 'unl']}
						/>
					</>
				)}
				{!isAlwaysSameFuelAndSupplier && (
					<div>
						<FMPSectionHeader label={'Supplier Matcher'} isTop={true} />
						{supplierRegexes.map((supplierRegex, i) => {
							const prefix = `supplierRegexes[${i}]`;
							return (
								<div key={prefix} className={classes.blockContainer}>
									<FMPText {...this.setForm(`${prefix}.regex`, 'Regex')} />

									<FMPSupplierPicker
										{...this.setForm(`${prefix}.supplierId`, 'Supplier')}
										terminalId={terminalId}
									/>
								</div>
							);
						})}

						<Button
							variant="contained"
							size="small"
							className={classes.addInputButton}
							onClick={() => this.addInput('supplierRegexes')}
						>
							ADD SUPPLIER MATCHER
						</Button>

						<FMPSectionHeader label={'Product Matcher'} />

						{productTypeRegexes.map((productRegex, i) => {
							const prefix = `productTypeRegexes[${i}]`;
							return (
								<div key={prefix} className={classes.blockContainer}>
									<FMPText {...this.setForm(`${prefix}.regex`, 'Regex')} />

									<FMPProductSelect
										{...this.setForm(`${prefix}.productType`, 'Product Type')}
										productTypes={['e85', 'etoh', 'unl']}
									/>
								</div>
							);
						})}

						<Button
							variant="contained"
							size="small"
							className={classes.addInputButton}
							onClick={() => this.addInput('productTypeRegexes')}
						>
							ADD PRODUCT MATCHER
						</Button>
					</div>
				)}
			</div>
		);
	};

	renderSaveButton = () => {
		const { isUpdate } = this.state;
		const { classes } = this.props;
		const action = isUpdate ? 'Update OCR Guide' : 'Create OCR Guide';
		return (
			<Button
				variant="contained"
				color="primary"
				className={classes.submitButton}
				onClick={this.handleSave}
			>
				{action}
			</Button>
		);
	};

	fakeUploadSuperiorResources = () => {
		async.eachSeries(
			[888888953, 888888954, 888888955],
			(resourceId, callback) => {
				const resource = { resourceId };
				this.createOcrGuideDocument({ resource, callback });
			},
			_.noop
		);
	};

	fakeUploadPdiResources = () => {
		async.eachSeries(
			[888888956, 888888957, 888888958],
			(resourceId, callback) => {
				const resource = { resourceId };
				this.createOcrGuideDocument({ resource, callback });
			},
			_.noop
		);
	};

	createOcrGuideDocument = ({ resource, callback }) => {
		const { ocrGuideDocumentAdd, showErrors } = this.props;
		const { resourceId } = resource;
		ocrGuideDocumentAdd({
			params: {
				resourceId,
			},
			callback: (err, apiResult) => {
				if (err) {
					return showErrors([err]);
				}

				const ocrGuideDocumentId = _.first(apiResult.ocrGuideDocumentIds);
				if (!ocrGuideDocumentId) {
					console.error(apiResult);
					return showErrors(['Missing ocrGuideDocumentId from apiResult']);
				}

				this.setState({
					ocrGuideDocumentIds: this.state.ocrGuideDocumentIds.concat(ocrGuideDocumentId),
				});
				if (_.isFunction(callback)) {
					return callback();
				}
			},
		});
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	renderDocumentPrep = () => {
		const { ocrGuideDocumentMap } = this.props;

		const { prepResult, ocrGuideDocumentIds } = this.state;

		if (prepResult) {
			return this.renderPrepResults();
		}

		return (
			<div>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<Button
						variant="contained"
						size="small"
						onClick={this.fakeUploadSuperiorResources}
						style={{ height: 30 }}
					>
						Fake Superior
					</Button>

					<Button
						variant="contained"
						size="small"
						onClick={this.fakeUploadPdiResources}
						style={{ height: 30 }}
					>
						Fake PDI
					</Button>

					{ocrGuideDocumentIds.map((ocrGuideDocumentId, i) => {
						const ocrGuideDocument = ocrGuideDocumentMap[ocrGuideDocumentId];
						if (!ocrGuideDocument) {
							return <div>Could not find ocrGuideDocumentId: {ocrGuideDocumentId}</div>;
						}

						return (
							<div
								key={ocrGuideDocumentId}
								style={{
									margin: 10,
									padding: 5,
									height: 60,
									width: 45,
									fontSize: 12,
									color: '#666',
									border: '1px solid #666',
									backgroundColor: '#f5f5f5',
								}}
							>
								Doc #{i + 1}
								<br />
								Id: {ocrGuideDocumentId}
							</div>
						);
					})}
					{ocrGuideDocumentIds.length < 3 && (
						<div>Upload 3 documents from the same vendor to analyze</div>
					)}
					{ocrGuideDocumentIds.length >= 3 && (
						<Button
							variant="contained"
							size="small"
							onClick={this.getBlockSuggestions}
							style={{ height: 30 }}
						>
							Run Analysis
						</Button>
					)}
				</div>

				<ResourceListing
					path={'resourceIds'}
					removeInput={this.removeInput}
					resourceIds={this.state.resourceIds}
					resourceMap={this.props.resourceMap}
				/>

				<ResourceUploader
					name={'resourceIds'}
					label={''}
					afterUpload={this.createOcrGuideDocument}
				/>
			</div>
		);
	};

	renderPrepResults = () => {
		const { classes } = this.props;
		const { prepResult } = this.state;

		//return (<div>Fetching prep results...</div>);

		const { firstDocKey, collections } = prepResult;

		const { ocrGuideDocumentCollection, resourceCollection } = collections;

		const firstDoc = _.find(ocrGuideDocumentCollection, { key: firstDocKey });
		const { resourceId } = firstDoc;
		const pdfResource = _.find(resourceCollection, { resourceId });

		const { url } = pdfResource;
		//const width = 612;
		//const height = 792;
		//const newWidth = 1400;
		//const newHeight = (height / width) * newWidth;

		/** @namespace Block.Geometry.BoundingBox.Top **/
		/** @namespace Block.Geometry.BoundingBox.Width **/
		/** @namespace Block.Geometry.BoundingBox.Height **/
		return (
			<>
				<FMPHeadline label="Add OCR Guide" />
				<Paper className={classes.paper}>
					<div style={{ textAlign: 'right' }}>
						<div
							style={{
								boxSizing: 'border-box',
								position: 'relative',
								border: '1px solid green',
							}}
						>
							<img alt={`doc`} src={url} style={{ width: '100%', opacity: 0.8 }} />

							{this.renderKeyBlocks()}
							{this.renderBlocks()}
						</div>
					</div>
				</Paper>
			</>
		);
	};

	renderKeyBlocks = () => {
		const { classes } = this.props;

		const { keyBlocks, currentPickingType } = this.state;

		if (currentPickingType !== 'keyAndValueBlocks') {
			return null;
		}

		let keyColorIndex = 0;

		return keyBlocks.map((Block, i) => {
			let box = Block.Geometry.BoundingBox;
			const { r, g, b } = rgbKeyValueColors[keyColorIndex];

			keyColorIndex += 6;
			if (keyColorIndex >= rgbKeyValueColors.length) {
				keyColorIndex = keyColorIndex - rgbKeyValueColors.length;
			}

			const border = `1px solid rgba(${r},${g},${b}, 1)`;
			const backgroundColor = `rgba(${r},${g},${b} ,.2)`;

			const keyStyle = {
				left: box.Left * 100 + '%',
				top: box.Top * 100 + '%',
				width: box.Width * 100 + '%',
				height: box.Height * 100 + '%',
				border,
				backgroundColor,
			};

			const { valueBlock } = Block;
			box = valueBlock.Geometry.BoundingBox;
			const valueStyle = {
				left: box.Left * 100 + '%',
				top: box.Top * 100 + '%',
				width: box.Width * 100 + '%',
				height: box.Height * 100 + '%',
				border,
				backgroundColor,
			};

			return (
				<Fragment key={`kv_${i}`}>
					<div
						style={keyStyle}
						className={clsx(classes.block, classes.keyBlocks)}
						onClick={() => {
							this.handlePickBlock({ Block });
						}}
					/>
					<div
						style={valueStyle}
						className={clsx(classes.block, classes.keyBlocks)}
						onClick={() => {
							this.handlePickBlock({ Block });
						}}
					/>
				</Fragment>
			);
		});
	};

	renderBlocks = () => {
		const { classes } = this.props;
		const { blocksById, currentPickingType, prepResult } = this.state;

		const {
			suggestedGuideIndicatorBlocksIds,
			suggestedKeyBlockIds,
			suggestedValueBlockIds,
		} = prepResult;

		console.log('Render blocks', currentPickingType);

		if (
			currentPickingType !== 'indicatorBlocks' &&
			currentPickingType !== 'anchorBlocks' &&
			currentPickingType !== 'allBlocks'
		) {
			return null;
		}

		let blockIds = [];
		let colorPattern = 'rainbow';
		if (currentPickingType === 'indicatorBlocks') {
			blockIds = suggestedGuideIndicatorBlocksIds;
			colorPattern = 'top10';
		} else if (currentPickingType === 'anchorBlocks') {
			blockIds = suggestedKeyBlockIds;
		} else if (currentPickingType === 'allBlocks') {
			blockIds = suggestedValueBlockIds;
		}

		let keyColorIndex = 0;
		return (
			<>
				{blockIds.map((Id, i) => {
					const Block = blocksById[Id];
					if (!Block) {
						return null;
					}
					const box = Block.Geometry.BoundingBox;

					let border, backgroundColor;

					if (colorPattern === 'top10') {
						if (i <= 10) {
							border = '1px solid rgba(139,195,74, 1)';
							backgroundColor = 'rgba(139,195,74 ,.2)';
						} else {
							border = '1px solid rgba(121,85,72 ,.8)';
							backgroundColor = 'rgba(121,85,72 ,.2)';
						}
					} else {
						const { r, g, b } = rgbKeyValueColors[keyColorIndex];
						keyColorIndex += 6;
						if (keyColorIndex >= rgbKeyValueColors.length) {
							keyColorIndex = keyColorIndex - rgbKeyValueColors.length;
						}
						border = `1px solid rgba(${r},${g},${b}, 1)`;
						backgroundColor = `rgba(${r},${g},${b} ,.2)`;
					}

					const style = {
						left: box.Left * 100 + '%',
						top: box.Top * 100 + '%',
						width: box.Width * 100 + '%',
						height: box.Height * 100 + '%',
						border,
						backgroundColor,
					};

					return (
						<div
							key={`sg1_${i}`}
							style={style}
							className={classes.block}
							onClick={() => {
								this.handlePickBlock({ Block });
							}}
						/>
					);
				})}
			</>
		);
	};
}

SaveOcrGuide.propTypes = {
	getBlockSuggestions: PropTypes.func.isRequired,
	ocrGuideAdd: PropTypes.func.isRequired,
	ocrGuideUpdate: PropTypes.func.isRequired,
	ocrGuideGet: PropTypes.func.isRequired,

	ocrGuideDocumentAdd: PropTypes.func.isRequired,
	ocrGuideDocumentMap: PropTypes.object,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	OcrGuideDocumentContainer,
	OcrGuideContainer,
])(SaveOcrGuide);
